import { IconName } from '@travelata-libs/ui-kit';

interface MobileMenuLink {
  label: string;
  href: string;
  icon: IconName;
  external?: boolean;
}

export const MOBILE_MENU_LINKS: MobileMenuLink[] = [
  { label: 'Поиск туров', href: '/search', icon: IconName.Search },
  { label: 'Горящие туры', href: '/tury', icon: IconName.Fire },
  { label: 'Поиск отелей', href: '/hotels/search', icon: IconName.Hotel },
  { label: 'Горнолыжные', href: '/ski', icon: IconName.Ski },
  { label: 'Отдых в России', href: '/russia', icon: IconName.Russian },
  { label: 'Раннее бронирование', href: '/earlybooking', icon: IconName.Clock },
  { label: 'Рейтинг туроператоров', href: '/rating', icon: IconName.StarEmpty },
  { label: 'Туры на выходные', href: '/weekend-tours/russia', icon: IconName.Tent },
  { label: 'Офисы продаж', href: '/regions', icon: IconName.Flag },
  { label: 'Календарь низких цен', href: '/calendar', icon: IconName.Calendar },
];
